import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

export const useTimerStore = create()(
  devtools(
    persist(
      (set) => ({
        min: 10,
        sec: 0,
        updateTimer: (min,sec) => set({min,sec}),
      }),
      { name: 'TimerStore' }
    )
  )
);
